import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { LazyComponent } from "./LazyComponent";
import "./LazyComponent.scss";
const SubscriptionsListBlock = React.lazy(() => import('../Components/SubscriptionsListBlock/SubscriptionsListBlock'));
const RelatedInsightsGridBlock = React.lazy(() => import('../Components/RelatedInsightsGridBlock/RelatedInsightsGridBlock'));
const FundCarouselListBlock = React.lazy(() => import('../Components/FundCarouselListBlock/FundCarouselListBlock'));
const FundCarouselUsBlock = React.lazy(() => import('../Components/FundCarouselUsBlock/FundCarouselUsBlock'));

//Bots
const isCrawler = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

const blockTypes = [
    {
        name: "SubscriptionsListBlock",
        tagName: "ve-subscriptionslist-block",
        component: SubscriptionsListBlock,
        LoadImmediately: false
    },
    {
        name: "RelatedInsightsGridBlock",
        tagName: "ve-relatedinsightsgrid-block",
        component: RelatedInsightsGridBlock,
        LoadImmediately: false
    },
    {
        name: "FundCarouselListBlock",
        tagName: "ve-personalizedfundcarousellistblock",
        component: FundCarouselListBlock,
        LoadImmediately: false
    },
    {
        name: "RecommendedFundCarouselListBlock",
        tagName: "ve-personalizedrecommendedfundcarousellistblock",
        component: FundCarouselListBlock,
        LoadImmediately: false,
    },
    {
        name: "FundCarouselUsBlock",
        tagName: "ve-fundcarouselusblock",
        component: FundCarouselUsBlock,
        LoadImmediately: false
    },
    {
        name: "RelatedInsightsGridBlock",
        tagName: "ve-personalizeinsightsgridblock",
        component: RelatedInsightsGridBlock,
        LoadImmediately: false
    },
]

export function processMarkup(rootElem = document) {
    //If it is a crawler, remove the blocks that are too slow to load.
    let blockTypesToRender = blockTypes;
    if (isCrawler) {
        blockTypesToRender = blockTypes.filter(block => {
            return typeof(block.IgnoreForCrawlers) == "undefined" || block.IgnoreForCrawlers == false;
        })
    }

    for (const block of blockTypesToRender) {
        var containers = rootElem.getElementsByTagName(block.tagName)
        if (block.template != null) {
            containers = Array.from(containers).filter(x => x.dataset.template == block.template)
        }
        for (const container of containers) {
            const root = createRoot(container);
            const { component, LoadImmediately } = block;
            root.render(
                <Suspense fallback={<div className="component-loading">Loading...</div>}>
                    <LazyComponent component={component} rootElement={container} loadImmediately={LoadImmediately} />
                </Suspense>
            );
        }
    }
}